import React from "react";

function useDebounce(value: any, delay: number) {
  const [debouncedValue, setDebounceValue] = React.useState<any>(null);

  React.useEffect(() => {
    const handler = setTimeout(() => {
      setDebounceValue(value);
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);
  
  return debouncedValue;
}

export default useDebounce;
